import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const BaseModalForm = ({ show, handleClose, handleSave, updating, title, children }) => (
  <Modal show={show} onHide={handleClose} size="lg" centered className="admin-container">
    <Modal.Header closeButton style={{ margin: '0px', padding: '30px', paddingBottom: '0px' }}>
      <Modal.Title className="m-0 ms-3">{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body className="pt-3">
      {children}
    </Modal.Body>
    <Modal.Footer style={{ borderTop: 'none', padding: '30px', paddingTop: '0px' }}>
      <Button variant="secondary" onClick={handleClose} disabled={updating}>
        Cancelar
      </Button>
      <Button variant="primary" onClick={handleSave} disabled={updating}>
        {updating ? 'Actualizando...' : 'Guardar'}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default BaseModalForm;